/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { LoadingState } from "@microsoft/shifts-models-view";
import { mutatorAction } from "satcheljs";

import { CreateActionsBaseParams } from "../CreateActionsBaseParams";

import { EntityListActions } from "./EntityListActions";
import { EntityListState } from "./EntityListState";

/**
 * Creates entity list actions.
 * @param params The parameters.
 * @returns The created actions.
 */
export function createEntityListActions<TEntity, TState extends EntityListState<TEntity>>(params: CreateActionsBaseParams<TState>): EntityListActions<TEntity> {
    const { namespace, store } = params;

    return {
        loadFailed: mutatorAction(`${namespace}LoadFailed`, (error: Error) => {
            store().error = error;
            store().loadingState = LoadingState.Failed;
        }),

        loadStarted: mutatorAction(`${namespace}LoadStarted`, () => {
            store().error = undefined;
            store().loadingState = LoadingState.Loading;
        }),

        loadSucceed: mutatorAction(`${namespace}LoadSucceed`, (values: TEntity[]) => {
            store().loadingState = LoadingState.Succeed;
            store().values = values;
        })
    };
}
